var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"material-icons-round",class:{
    active: !_vm.val,
    deactive: _vm.val,
  }},[_vm._v(" "+_vm._s(_vm.val ? _vm.deactiveLabel : _vm.activeLabel)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }